import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faCheck } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { usePrototype, inviteLink } from './PrototypeContext'
import ShareButton from './ShareButton'
import { DEFAULT_PROGRESSION as P } from '../../rules/progression/config'
import '../LobbyScreen.css'
import './prototype.css'

// The war a friend started by accepting this challenge, if there is one yet:
// the newest war of its kind with the challenger as p1 (challengeAccept seats
// them there) that began after the challenge was made. Both times are the
// server's: the challenge was made inviteExpiryHours before it expires.
export function acceptedWar(wars, uid, { mode, generated, expiresAt }) {
    const madeAt = expiresAt - P.inputs.inviteExpiryHours * 3600 * 1000
    return wars.find(w => w.mode === mode && w.players.p1.uid === uid && w.createdAt >= madeAt && !!w.generated === !!generated) ?? null
}

// A challenge just made: its code to read out or copy, its link to share, and
// the wait for the friend. Their accepting opens the war. Leaving doesn't undo
// the challenge: it stays open, and the war turns up in War history.
export default function WaitingRoom() {
    const { uid, wars, screen, openWar, goHome } = usePrototype()
    const { challenge } = screen
    const [copied, setCopied] = useState(false)

    const warId = acceptedWar(wars, uid, challenge)?.id
    useEffect(() => { if (warId) openWar(warId) }, [warId]) // eslint-disable-line react-hooks/exhaustive-deps

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(challenge.code)
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch { /* nothing to do: the code is on screen */ }
    }

    return (
        <div className="pt-screen">
            <header className="pt-menu__head">
                <button className="pt-back" onClick={goHome} aria-label="Back to home">
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h1 className="pt-menu__title">Waiting room</h1>
            </header>

            <div className="pt-waiting">
                <p className="lobby-label">Share this code with your friend</p>
                <div className="lobby-code-row" onClick={copy} title="Copy code">
                    <div className="lobby-room-code"><span className="lobby-room-code__text">{challenge.code}</span></div>
                    <div className={`lobby-copy-btn${copied ? ' lobby-copy-btn--copied' : ''}`}>
                        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                    </div>
                </div>
                <ShareButton url={inviteLink(challenge.code)} text={`Fight me in Hog of War: ${challenge.code}`} className="lobby-btn-primary" />
                <p className="pt-dim">
                    {challenge.mode === 'sync' ? 'Sync' : 'Async'} war{challenge.generated ? `, on generated Hives (${challenge.generated} structures)` : ''}
                </p>
                <p className="lobby-waiting-text">Waiting for your friend to accept...</p>
                <p className="pt-dim pt-waiting__note">
                    The code works for {P.inputs.inviteExpiryHours} hours. You can leave this screen: once they accept, the war is in War history.
                </p>
            </div>
        </div>
    )
}
